<template>
  <el-config-provider :locale="locale">
    <router-view />
  </el-config-provider>
</template>

<script>
import { messages } from '@/lang'

export default {
  name: 'App',
  computed: {
    locale () {
      for (const localeCode in messages) {
        if (this.$i18n.locale === localeCode) { return messages[localeCode] }
      }
    },
    colorScheme () {
      return this.$store.getters.colorScheme
    }
  },
  watch: {
    colorScheme (newVal, oldVal) {
      if (newVal !== oldVal) {
        document.querySelector('html').classList.add(newVal)
        document.querySelector('html').classList.remove(oldVal)
      }
    }
  },
  mounted () {
    const htmlElem = document.querySelector('html')

    if (this.colorScheme === 'dark') {
      htmlElem.classList.add('dark')
      htmlElem.classList.remove('light')
    } else {
      htmlElem.classList.add('light')
      htmlElem.classList.remove('dark')
    }
  }
}
</script>
